import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Home, Menu } from 'lucide-react';
import CartModal from '../cart/CartModal';
import MobileMenu from './MobileMenu';
import CartIcon from '../cart/CartIcon';

const FooterNavWrapper = styled.div`
  background-color: #333;
  padding: 10px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;

  @media (min-width: 992px) {
    display: none;
  }
`;

const FooterNavContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
`;

const FooterNavItem = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  text-align: center;
  cursor: pointer;

  svg {
    margin-bottom: 5px;
  }

  &:hover {
    color: #4CAF50;
  }
`;



const FooterNav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleCartModal = () => {
    setIsCartModalOpen(!isCartModalOpen);
  };

  return (
    <FooterNavWrapper>
      <FooterNavContainer>
        <FooterNavItem onClick={toggleMobileMenu}>
          <Menu size={24} />
       
        </FooterNavItem>

        <FooterNavItem onClick={toggleCartModal}>
        <CartIcon onClick={toggleCartModal} />
        
        </FooterNavItem>

        <FooterNavItem as={Link} to="/">
          <Home size={24} />
       
        </FooterNavItem>
      </FooterNavContainer>

      {/* Modals for Cart and Mobile Menu */}
      <CartModal isOpen={isCartModalOpen} onClose={toggleCartModal} />
      <MobileMenu isOpen={isMobileMenuOpen} onClose={toggleMobileMenu} />
    </FooterNavWrapper>
  );
};

export default FooterNav;